<template>
  <div class="checkbox-wrapper-21">
    <label class="control control--checkbox">
      <slot name="label">
        {{ props.label }}
      </slot>
      <input v-model="modelValue" type="checkbox" :required="props.required" />
      <div class="control__indicator"></div>
    </label>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  label?: string
  required?: boolean
}>()

const modelValue = defineModel<boolean>()

</script>

<style scoped>
@reference '~/style.css';

.checkbox-wrapper-21 {
  @apply tw:mt-3 tw:md:mt-0 tw:md:ml-3;
  align-content: center;
}

.checkbox-wrapper-21 .control {
  display: block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}
.checkbox-wrapper-21 .control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.checkbox-wrapper-21 .control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
  border-radius: 4px;
}
.checkbox-wrapper-21 .control:hover input ~ .control__indicator,
.checkbox-wrapper-21 .control input:focus ~ .control__indicator {
  background: #ccc;
}
.checkbox-wrapper-21 .control input:checked ~ .control__indicator {
  background: #41c02a;
}
.checkbox-wrapper-21 .control:hover input:not([disabled]):checked ~ .control__indicator,
.checkbox-wrapper-21 .control input:checked:focus ~ .control__indicator {
  background: #56a40d;
}
.checkbox-wrapper-21 .control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.checkbox-wrapper-21 .control__indicator:after {
  content: '';
  position: absolute;
  display: none;
}
.checkbox-wrapper-21 .control input:checked ~ .control__indicator:after {
  display: block;
}
.checkbox-wrapper-21 .control--checkbox .control__indicator:after {
  left: 7px;
  top: 3px;
  width: 6px;
  height: 12px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.checkbox-wrapper-21 .control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}
</style>